import React, { useEffect, useState } from "react";
import CustomTable from "../SessionCategoryManagement/CustomTable";
import styles from "../../_css/CustomTable.module.css";
import CollapsibleSection from "../common/CollapsibleSection";
import Pagination from "../UI/Pagination";
import TrainAIPopup from "./TrainAIPopup";
import { useDispatch, useSelector } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { fetchCategories, getSessions } from "../../requests";
import { deleteAuthToken } from "../../utils/helper";
import useDebounce from "../hooks/useDebounce";

const headers = ["Session Title", "Mode", "Date", "Summary Edited"];

const SEARCH_CONFIG = {
  column: "Session Title",
  placeholder: "Search by session title...",
};

const PAGE_SIZE = 5;

function TrainingHistory() {
  const [openSection, setOpenSection] = useState(null);
  const [categorySections, setCategorySections] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: PAGE_SIZE,
    hasNextPage: false,
    hasPrevPage: false,
    nextPage: null,
    prevPage: null,
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [data, setData] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [visibilityFilter, setVisibilityFilter] = useState(false);
  const [dateFilter, setDateFilter] = useState({});
  const [modeFilter, setModeFilter] = useState(null);
  const [summaryFilter, setSummaryFilter] = useState(99);

  const dispatch = useDispatch();
  const { refreshSession } = useSelector((state) => state.refreshSessionData);
  const debouncedSearchValue = useDebounce(searchValue, 300);

  useEffect(() => {
    getAllCategories(1);
  }, []);

  useEffect(() => {
    if (selectedCategory?.session_count > 0) {
      // Reset search when category changes
      setSearchValue("");
      fetchSessions(1, 5);
    } else {
      setData({});
    }
  }, [selectedCategory, refreshSession, modeFilter, summaryFilter, dateFilter]);

  // Effect to handle debounced search
  useEffect(() => {
    if (
      selectedCategory?.session_count > 0 &&
      debouncedSearchValue !== undefined
    ) {
      fetchSessions(1, 5);
    }
  }, [debouncedSearchValue]);

  const fetchSessions = async (page = 1, limit = 5) => {
    dispatch(startLoader());
    try {
      const response = await getSessions({
        categoryId: selectedCategory?.id,
        page,
        limit,
        modeFilter,
        summaryFilter,
        search: debouncedSearchValue,
        dateFilter,
      });

      const rows = response.data.sessions;
      const pagination = response.data.pagination;

      setData({
        headers,
        rows,
        pagination,
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    dispatch(stopLoader());
  };

  const handleRowClick = (row) => {
    console.log(row);
  };

  const handlePageChange = (newPage) => {
    getAllCategories(newPage);
  };

  const handlePageChangeTable = (newPage) => {
    fetchSessions(newPage, 5);
  };

  const getAllCategories = async (page = 1) => {
    dispatch(startLoader());
    try {
      const response = await fetchCategories({
        isPagination: true,
        page,
        limit: PAGE_SIZE,
      });

      setCategorySections(response.data.categoryResult);

      // Set pagination data from API response
      if (response.data.pagination) {
        setPagination(response.data.pagination);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    dispatch(stopLoader());
  };

  const resetFilters = () => {
    setModeFilter(null);
    setSummaryFilter(99);
    setDateFilter({});
  };

  const handleCategoryClick = (value, globalIndex) => {
    resetFilters();
    setSelectedCategory(value);
    setOpenSection(openSection === globalIndex ? null : globalIndex);
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  const handleDateFilterChange = (value) => {
    setDateFilter(value);
  };

  const handleModeChange = (value) => {
    setModeFilter(value?.value);
  };

  const handleSummaryChange = (value) => {
    setSummaryFilter(value?.value);
  };

  return (
    <div
      style={{
        width: "75%",
        margin: "32px auto",
        borderRadius: "14px",
        backgroundColor: "#fff",
        paddingBottom: "12px",
      }}
    >
      <h5
        style={{
          padding: "12px 16px 0 16px",
          color: "#132958",
          fontWeight: "600",
        }}
      >
        Training History
      </h5>
      <hr className="m-0" />
      {categorySections.map((value, index) => {
        const globalIndex =
          (pagination.currentPage - 1) * pagination.itemsPerPage + index;
        return (
          <div key={globalIndex} className={styles.tableContainer}>
            <CollapsibleSection
              title={value.name}
              headerClassName={styles.collapsibleHeader}
              open={openSection === globalIndex}
              onHeaderClick={() => handleCategoryClick(value, globalIndex)}
            >
              {data?.rows && (
                <CustomTable
                  rows={data.rows}
                  headers={data.headers}
                  onRowClick={() => {}}
                  searchConfig={SEARCH_CONFIG}
                  pagination={data.pagination}
                  onPageChange={handlePageChangeTable}
                  onModeChange={handleModeChange}
                  onSummaryChange={handleSummaryChange}
                  onSearchChange={handleSearchChange}
                  searchValue={searchValue}
                  onDateFilterChange={handleDateFilterChange}
                  trainingHistory={true}
                />
              )}
              {/* <CustomTable
                rows={rows}
                headers={headers}
                onRowClick={handleRowClick}
                searchConfig={SEARCH_CONFIG}
              /> */}
            </CollapsibleSection>
          </div>
        );
      })}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 16,
        }}
      >
        <div className={styles.tableFooter}>
          Showing {(pagination.currentPage - 1) * pagination.itemsPerPage + 1}–
          {Math.min(
            pagination.currentPage * pagination.itemsPerPage,
            pagination.totalItems
          )}{" "}
          of {pagination.totalItems} Sections
        </div>
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
}

export default TrainingHistory;
